import React, { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ListGroup,
  ListGroupItem,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input
} from 'reactstrap';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { toast } from 'react-toastify';

class DocListModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      docs: [],
      selectedDoc: null,
      isEditing: false,
      editedContent: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ docs: nextProps.docs });
  }

  handleDocClick = (doc) => {
    this.setState({ 
      selectedDoc: doc,
      isEditing: false,
      editedContent: doc.content
    });
  };

  handleEditClick = () => {
    this.setState({ 
      isEditing: true,
      editedContent: this.state.selectedDoc.content
    });
  };

  handleSaveClick = async () => {
    const { selectedDoc, editedContent, docs } = this.state;
    if (selectedDoc) {
      const updatedDoc = {
        ...selectedDoc,
        content: editedContent
      };
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/k3doc`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updatedDoc)
        });
        console.log(response.status);
        if (response.status != 200) {
          throw new Error('Failed to save document');
        }

        // const savedDoc = await response.json();
        this.setState({ 
          isEditing: false,
        //   selectedDoc: savedDoc,
          docs: docs.map(doc => doc._id === savedDoc._id ? savedDoc : doc)
        });
        toast.success('Document saved successfully!');
      } catch (error) {
        console.error('Error saving document:', error);
        toast.error('Failed to save document. Please try again.');
      }
    }
  };

  handleSaveNewVersionClick = async () => {
    const { selectedDoc, editedContent } = this.state;
    if (selectedDoc) {
      const { _id, ...docWithoutId } = selectedDoc;
      const updatedDoc = {
        ...docWithoutId,
        content: editedContent
      };
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/k3doc?generate_version=true`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updatedDoc)
        });
        if (!response.status != 200) {
          throw new Error('Failed to save new version');
        }
        const savedDoc = await response.json();
        this.setState({ 
          isEditing: false,
          selectedDoc: savedDoc
        });
        toast.success('New version saved successfully!');
      } catch (error) {
        console.error('Error saving new version:', error);
        toast.error('Failed to save new version. Please try again.');
      }
    }
  };

  handleCancelClick = () => {
    this.setState({ 
      isEditing: false,
      editedContent: this.state.selectedDoc.content
    });
  };

  handleContentChange = (e) => {
    this.setState({ editedContent: e.target.value });
  };

  getRefMessageId = (doc) => {
    if (doc.ref_id) {
        return doc.ref_id.replace('message_', '');
    }
    return "";
  }

  render() {
    const { isOpen, toggle, title } = this.props;
    const { docs } = this.state;
    const { selectedDoc, isEditing, editedContent } = this.state;

    if (docs == null || docs.length == 0) {
      return "";
    }

    return (
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xl modal-dialog-centered modal-doc-list" style={{ 
        maxWidth: '95vw',
        margin: '0 auto'
      }}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody style={{ 
          height: '80vh',
          overflowY: 'auto',
          padding: '1rem'
        }}>
          <div className="row h-100">
            <div className="col-md-3" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
              <ListGroup style={{ position: 'sticky', top: 0 }}>
                {docs.map(doc => (
                  <ListGroupItem
                    key={doc._id}
                    tag="button"
                    action
                    onClick={() => this.handleDocClick(doc)}
                    active={selectedDoc?._id === doc._id}
                    className="text-truncate"
                  >
                    {doc.title || doc._id}
                  </ListGroupItem>
                ))}
              </ListGroup>
            </div>
            <div className="col-md-9">
              {selectedDoc ? (
                <Card className={`h-100 doc-bg-${selectedDoc.metadata.message_role}`}>
                  <CardBody style={{ overflowY: 'auto' }}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <span>
                        <a href={`/v1/k3pl-chat?messageId=${this.getRefMessageId(selectedDoc)}`} target="_blank" rel="noopener noreferrer">Message ID: {this.getRefMessageId(selectedDoc)}</a>
                      </span>
                      <h5>{selectedDoc.title || selectedDoc._id}</h5>
                      {!isEditing && (
                        <Button color="primary" size="sm" onClick={this.handleEditClick}>
                          Edit
                        </Button>
                      )}
                    </div>
                    {isEditing ? (
                      <Form>
                        <FormGroup>
                          <Input
                            type="textarea"
                            value={editedContent}
                            onChange={this.handleContentChange}
                            style={{ height: '60vh', fontFamily: 'monospace' }}
                          />
                        </FormGroup>
                        <div className="d-flex justify-content-end mt-2">
                          <Button color="secondary" size="sm" className="me-2" onClick={this.handleCancelClick}>
                            Cancel
                          </Button>
                          <Button color="primary" size="sm" className="me-2" onClick={this.handleSaveClick}>
                            Save
                          </Button>
                          <Button color="success" size="sm" onClick={this.handleSaveNewVersionClick}>
                            Save New Version
                          </Button>
                        </div>
                      </Form>
                    ) : (
                      <ReactMarkdown
                        remarkPlugins={[remarkGfm]}
                        rehypePlugins={[rehypeRaw]}
                        children={selectedDoc.content}
                      />
                    )}
                  </CardBody>
                </Card>
              ) : (
                <div className="text-center h-100 d-flex align-items-center justify-content-center">
                  <p>Select a document to view its content</p>
                </div>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>Close</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default DocListModal; 